module.exports = __webpack_public_path__ + "media/images/home/restuarent-banner-5485bf76829f825fd5d7c2b8683a9ed5.png";